import { FilterMatchMode } from 'primereact/api';

export const MenuPermiso = {
    controlador: {
        header: 'Controlador',
        table: true,
        sort: true,
        filter: true,
        matchMode: FilterMatchMode.CONTAINS
    },
    accion: {
        header: 'Acción',
        table: true,
        sort: true,
        filter: true,
        matchMode: FilterMatchMode.CONTAINS
    },
    crud: {
        header: 'CRUD',
        table: true,
        sort: true,
        filter: false,
        style: { width: '20%' }
    },
    fecha: {
        header: 'Fecha Asignación',
        table: true,
        sort: true,
        filter: false,
        isDate: true,
        style: { width: '20%' }
    }
};
